<script>
import EditUser from "../data/EditUser";
import UserValidator from "../data/UserValidator";

import PropertyTable from "../../../common/property-table.vue";
import {translations} from "../data/variables";

    export default
    {
        name: 'user-wizard-projects',
        components: {PropertyTable},
        props: {
            user: EditUser,
            validator: UserValidator
        },
        computed: {
            translations() {
                return translations
            }
        },
        mounted() {
            // initial validation
            this.$emit('valid', 'selectedProjects');
        }
    }
</script>

<template>
    <div class="d-flex flex-column pa-2 overflow-y-auto">
        <property-table
            :items="user.getAllProjects(true)"
            :propertyName="translations.project"
            searchable
            @input="value => $emit('input', 'selectedProjects', value)"
            @selectAll="value => $emit('selectAll', 'selectedProjects', value)"
        />
        <h3 v-if="validator.isInvalid('selectedProjects')" class="bg-danger rounded pa-2 text-center">
            {{user.isLdap ? translations.exactlyOneProject : translations.atLeastOneProject}}
        </h3>
    </div>
</template>

